export default __webpack_public_path__ + "static/topNavItems-anatomy-light-e6411df4e079ed100844241e4519fdbda68d10037ee56430c43e1ce578b35ce5.png";